// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store';
import i18n from './i18n/lang.js';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios';
import VModal from 'vue-js-modal'
// import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.css';
import { mapGetters } from 'vuex';


//Vue.use(VModal, {dialog: true, dynamic: true, injectModalsContainer: true})
Vue.use(VModal, {dynamic: true, injectModalsContainer: true})

/**
* http配置
*/

// 引入axios以及element ui中的loading和message組件
// 超時時間

axios.defaults.timeout = 600000
Vue.config.productionTip = false
Vue.prototype.$http = axios

Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
})
Vue.use(Viewer)
Viewer.setDefaults({
  zIndexInline: 2017
})
 
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  data: {
    sysNo: '101'
  },
  components: { App },
  template: '<App/>',
  methods: {
    getConfigureInfo: function (sysId) {
      return this.$http
                 .get('./WebApi/Common/GetConfigureList/'.concat(sysId));
    },
    getEnrollInfo: function (sysId) {
      return this.$http
                 .get('./WebApi/Common/GetEnrollSetting/'.concat(sysId));
    }
  },
  created () {
    console.log('======created=====')
    this.$store.dispatch('setSysNo', this.sysNo)
    var vm = this
    this.$http
      .get('./WebApi/Common/GetSystemId/'.concat(this.sysNo))
      .then(function (response) {
        vm.$store.dispatch('setSysId', response.data)
        vm.$http.all([vm.getConfigureInfo(response.data), vm.getEnrollInfo(response.data)])
        .then(vm.$http.spread(function (conInfo, enrollInfo, pageInfo) {
          vm.$store.dispatch('setSetting', JSON.parse(conInfo.data))
          vm.$store.dispatch('setEnrollInfo', enrollInfo.data)
          vm.$store.dispatch('toggleLoading', false)
          if (0 == vm.$store.getters.getSysMode) {
            router.push('/main')
          }
        }))
      })
  }
})

// http請求攔截器
// const vueApp = new Vue(App).$mount('#app')
axios.interceptors.request.use(config => {
  // element ui Loading方法
  if (store.getters.getCount === 0) {
    store.dispatch('toggleLoading', true)
  }
  store.dispatch('actionIncrease')
  return config
}, error => {
  console.log('request.use: 加載超時' + store.getters.getCount)
  store.dispatch('actionDecrease')
  if (store.getters.getCount === 0) {
    store.dispatch('toggleLoading', false)
  }
  return Promise.reject(error)
})

// http響應攔截器
axios.interceptors.response.use(data => { // 響應成功關閉loading
  store.dispatch('actionDecrease')
  if (store.getters.getCount === 0) {
    store.dispatch('toggleLoading', false)
  }
  return data
}, error => {
  console.log('response.use: 對不起,服務端發生錯誤' + store.getters.getCount)
  store.dispatch('actionDecrease')
  if (store.getters.getCount === 0) {
    store.dispatch('toggleLoading', false)
  }
	var originalRequest = error.config;
	if(error.code == 'ECONNABORTED' && error.message.indexOf('timeout')!=-1 && !originalRequest._retry){
		originalRequest._retry = true
		return axios.request(originalRequest);
	} else {
    store.dispatch('actionResetCount')
    store.dispatch('toggleLoading', false)
    alert('對不起,網路連線失敗' + error+'，請您稍後再試!');
  }
  return Promise.reject(error)
})


// WEBPACK FOOTER //
// ./src/main.js